'use strict';

define('vb/private/stateManagement/extensionScope',['vb/private/utils',
], (Utils) => {
  /**
   * A simple extension scope class used for the purpose of resolving extension types.
   * Normally scope objects are full-fledged container types, and similar methods are implemented on the container
   * classes. But extensions are not containers and only types are currently allowed to be defined in an extension
   * descriptor.
   */
  class ExtensionScope {
    constructor(extension, container) {
      this.id = extension && extension.id;
      /**
       * @private
       */
      this.extension = extension;
      this.definition = extension && extension.extensionResources.definition;
      this.container = container; // generally types are resolved when variables in the container are being initialized
    }

    get scopeResolver() {
      return this.container && this.container.scopeResolver;
    }

    /**
     * Returns the type definition if the type is either in the interface or the local
     * @param {string} name
     * @return {*}
     */
    hasType(name) {
      const checkType = (typesRoot = {}) => typesRoot.types && typesRoot.types[name];

      // types defined in interface have precedence. There is an audit in DT to catch duplicates
      return (checkType(this.definition.interface) || checkType(this.definition));
    }

    /**
     * Returns the type definition for the type. If type is not found throws TypeError
     * @param {string} name of the type
     * @returns {{ type: *} }
     * @throws {TypeError}
     */
    getType(name) {
      const typeDef = this.hasType(name);

      if (!typeDef) {
        throw new TypeError(`Type "${name}" does not exist in extension`
          + `${this.id} ${this.definition.id}`);
      }

      // legacy type definition
      // Note: If you have a legacy type definition as follow:
      // types: {
      //   foo: {
      //     "type": "string"
      //   }
      // }
      // we will favor the new syntax over the legacy syntax so in the above example,
      // type foo will be resolved to an object with a string property called type.
      // We believe it is very unlikely to have a legacy type definition that is simply an
      // alias for a primitive type.
      if ((typeDef.type === 'object' || typeDef.type === 'array')
        && (typeDef.definition === '*' || Utils.isObject(typeDef.definition))) {
        return typeDef;
      }

      // make it consistent with type definition on a variable
      return {
        type: typeDef,
      };
    }

    /**
     * Returns true if the type is defined in the interface section of the current container.
     * @param name of the type
     * @returns {*}
     */
    isInterfaceType(name) {
      const defs = this.definition;
      return defs && defs.interface && defs.interface.types[name];
    }
  }

  return ExtensionScope;
});

